<template lang="pug">
  .content
    .md-layout.md-gutter.md-alignment-center-center
      .md-layout-item.md-size-40.md-medium-size-55.md-xsmall-size-100
        form(@submit.prevent="" autocomplete="on")
          md-card
            md-card-header(data-background-color="green")
              h4(class="title") Sign in
              p(class="category") Please sign in with your EID and password.
            md-card-content
              .md-layout
                .md-layout-item.md-size-100
                  md-field
                    md-icon person
                    label UT EID
                    md-input(v-model="eid" type="text" required autocomplete="username")
                .md-layout-item.md-size-100
                  md-field
                    md-icon lock
                    label Password
                    md-input(v-model="password" type="password" required autocomplete="password")
                .text-center.md-layout-item
                  h6(v-if="error" style="color: red") Sorry, there was an error logging in. Please try again.
                  md-button(type="submit" v-on:click="signIn") Login
                  h6 Don't have an account? 
                    router-link(:to='{ name: "Register" }') Register here
                  h6 Forgot password? 
                    router-link(to='loginreset') Reset Password
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      eid: '',
      password: '',
      error: false,
    };
  },
  created() {
    if (this.$store.state.user) {
      this.$router.replace('Dashboard');
    }
  },
  methods: {
    signIn() {
      let load = {
        username: this.eid.toLowerCase(),
        password: this.password
      };
      this.error=false;
      axios.post('/api/login', load)
      .then((response) => {
        this.$store.commit('updateUser', response.data);
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else { 
          this.$router.push({name: 'Dashboard'});
        };
      }).catch(() => {
        this.error = true;
      });
    },
  }
}
</script>

<style scoped>
  form{
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/Signin.vue